import { cn } from '@portals-platform/ui';
import type * as React from 'react';

export type ColSpan = 3 | 4 | 6 | 8 | 12;

/**
 * Spans apply from the `md` breakpoint up; below it every field is full width.
 *
 * The grid was previously unconditional, so a `col={3}` field rendered as a quarter-width
 * column on a phone and the form was unusable. Callers keep passing the same desktop span
 * they always did — the stacking is free.
 */
const colClass: Record<ColSpan, string> = {
  3: 'col-span-12 md:col-span-3',
  4: 'col-span-12 md:col-span-4',
  6: 'col-span-12 md:col-span-6',
  8: 'col-span-12 md:col-span-8',
  12: 'col-span-12',
};

export function colSpanClass(col: ColSpan): string {
  return colClass[col];
}

interface FormGridProps {
  children: React.ReactNode;
  className?: string;
}

export function FormGrid({ children, className }: FormGridProps) {
  return <div className={cn('grid grid-cols-12 gap-5', className)}>{children}</div>;
}
